import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import Header from './components/header'
import Sidebar from './components/sidebar'
import { BrowserRouter } from 'react-router-dom'
import Route from './components/route'
import PropTypes from 'prop-types'
import Login from './login'
import Error403 from './error403'
import hoc from '@hoc'
import { withTranslation } from 'react-i18next'
import * as utils from '@utils'
import { API } from '@const'

class App extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props)
        
    }

    state = {
        sidebarSwitch: true,
        ipVerify: false,
        ipVerifyError: false,
        ip: ''
    }

    componentDidMount() {
        utils.apiRequest(
            'get',
            API.IP_VERIFY,
            {},
            () => {
                this.props.authInit()
                this.setState({
                    ipVerify: true, 
                    ipVerifyError: false
                })
            },
            (error) => {
                this.props.authLogout()
                const { data } = error
                this.setState({
                    ipVerify: true, 
                    ipVerifyError: true,
                    ip: data.ip
                })
            },
            true,
            null,
            true
        )
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.auth?.hasLogin && !nextProps.dataService.hasInit) this.props.dataServiceInit()

        return true
    }

    switchSidebar = () => {
        this.setState({
            sidebarSwitch: !this.state.sidebarSwitch,
        })
    }

    render() {
        /** 尚未經過IP驗證不顯示任何內容 */
        if (!this.state.ipVerify) {
            return 'Loading...'
        }
        /** IP驗證失敗 */
        if (this.state.ipVerify && this.state.ipVerifyError) {
            return <Error403 ip={this.state.ip} />
        }
        if (!this.props.auth.hasLogin) {
            return <Login />
        }
        if (!this.props.dataService.hasInit) {
            return 'Loading...'
        }

        return (
            <BrowserRouter>
                <div className={this.props.classes.root}>
                    <CssBaseline />
                    <Header switchSidebar={this.switchSidebar} sidebarSwitch={this.state.sidebarSwitch}></Header>
                    <Sidebar switchSidebar={this.switchSidebar} sidebarSwitch={this.state.sidebarSwitch}></Sidebar>
                    <main className={this.props.classes.content}>
                        <div className={this.props.classes.toolbar} />
                        <div style={{position: 'relative'}}>
                            <div className={this.props.classes.waterMark} />
                            <Route />
                        </div>
                    </main>
                </div>
                <div id="treeSelectBox" className={this.props.classes.treeSelectBox}></div>
            </BrowserRouter>
        )
    }
}

App.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    sidebarSwitch: PropTypes.shape({
        value: PropTypes.bool,
        setValue: PropTypes.func,
    }),
    authInit: PropTypes.func,
    auth: PropTypes.object,
    dataServiceInit: PropTypes.func,
    dataService: PropTypes.object,
    t: PropTypes.func,
    authLogout: PropTypes.func
}

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    treeSelectBox: {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999
    },
    waterMark: {
        position: 'absolute',
        inset: 0,
        opacity: 0.7,
        zIndex: 9999,
        pointerEvents: 'none',
        overflow: 'hidden',
        backgroundImage: `url("/images/water.png")`,
        backgroundColor: 'transparent',
        backgroundRepeat: 'repeat'
    }
})

export default withTranslation(['translation', 'code', 'common', 'game'])(hoc(styles)(App))
